import React from "react"
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core'
import { GlobalStyle } from '../utils/styles'
import SaFront from './svg/sa-front'
import SaBack from './svg/sa-back'
import QpFront from './svg/qp-front'
import QpBack from './svg/qp-back'
import { useTranslation } from "react-i18next"

const ComponentSelect = ({ currentProduct, changeSide, currentComp, compSelectClick, currentDesign, finishDesign, tagSelectClick, gotoDesignStage, classes, title, resetAll, checkSavable, backtoDesignStage, currentTag, scrollLeft, updateScrollLeft }) => {
  const scrollableNodeRef = React.useRef(null);
  React.useEffect(() => {
    scrollableNodeRef.current.scrollLeft = scrollLeft
  }, [scrollLeft]);
  const scrollNavigation = (move) => {
    scrollableNodeRef.current.scrollTo({
      left: scrollableNodeRef.current.scrollLeft + move,
      behavior: 'smooth'
    });
  }

  const { t } = useTranslation()

  return (
    <div className="componentSelect">
      <h2 className="desktop">{title}</h2>
      <button className="resetButton desktop" onClick={() => resetAll()}>{ t('product.reset') }</button>
      <div className="scrollButton-container" ref={scrollableNodeRef}>
        {currentDesign.case.map((item, index) => 
          <div key={index} className="button__container">
            <Button
            onClick={() => {compSelectClick(index); changeSide(index); updateScrollLeft(scrollableNodeRef.current.scrollLeft)}}
            style={{
              backgroundColor: currentComp === index ? '#eee' : 'transparent'
            }}
            key={index}>
              {(currentProduct === 'sacoche' && index === 4) ? (
                <SaBack highlight={item.comp} />
              ) : (currentProduct === 'sacoche' && index !== 4) ? (
                <SaFront highlight={item.comp} />
              ) : (currentProduct !== 'sacoche' && index === 4) ? (
                <QpBack highlight={item.comp} />
              ) : (
                <QpFront highlight={item.comp} />
              )}
              <i className={`icon icon-tick ${item.color === 'white' &&  item.comp !== 'zipper' || item.color === '' &&  item.comp === 'zipper' ? '' : 'fulfilled'}`} />
            </Button>
            <div className="button__label">{ t('product.component')[item.comp] }</div>
          </div>
        )}
        {/* <div className="button__container">
          <Button
            onClick={() => tagSelectClick()}
            style={{
              backgroundColor: currentComp === 'tag' ? '#eee' : 'transparent'
            }}
          >
            {currentProduct === 'sacoche' ? (
              <SaFront highlight={'label'} />
            ) : (
              <QpFront highlight={'label'} />
            )}
            <i className={`icon icon-tick ${currentTag.length > 0 ? 'fulfilled' : ''}`} />
          </Button>
          <div className="button__label">{ t('product.component.tag') }</div>
        </div> */}
      </div>
      <button onClick={() => scrollNavigation(-240)} className="scrollButton-prev mobile"><i className="icon icon-prevs"/></button>
      <button onClick={() => scrollNavigation(240)} className="scrollButton-next mobile"><i className="icon icon-nexts"/></button>
      <div className="buttonGroup stickToBottom">
        <Button
          onClick={() => backtoDesignStage()}
          className="basicButton outline">
          { t('product.cancel') }
        </Button>
        <Button
          className={`basicButton ${checkSavable ? '' : 'disable'}`}
          onClick={() => {finishDesign(); gotoDesignStage()}}>
          { t('product.saveDesign') }
        </Button>
      </div>
    </div>
  )
}

export default withStyles(GlobalStyle)(ComponentSelect)
